import type { ApiProduct } from '../../../../../models/ecommerce/product/ApiProduct';
import type { ProductListingItemData } from './ProductListingItem.types';

import { getMedicalProductTeaserMessage } from '../../../../common/components/atoms/MedicalInfo/MedicalInfo';
import { addSwedishLabel } from '../../../../ecommerce/components/ProductInfoProperty/ProductInfoProperty.utils';

export const mapToProductListingItemData = (input: ApiProduct): ProductListingItemData => {
    return {
        identifier: input.identifier,
        name: input.name,
        imageUrl: input.image?.url,
        manufacturer: input.manufacturer,
        url: input.url,
        packageSize: {
            size: input.details.size.size,
            unit: input.details.size.unit,
        },
        packageSizeInformation: input.details.size.packageSizeInformation,
        attributeLabels: addSwedishLabel({
            fromSweden: input.details.fromSweden || false,
            attributeLabels: input.details.attributes || [],
        }),
        consumerInformationText: [
            ...(input.details.consumerInformationText || []),
            ...getMedicalProductTeaserMessage({
                isPharmaceutical: input.details.pharmaceuticalData?.isPharmaceutical || false,
                isNicotineProduct: input.details.isNicotineProduct || false,
            }),
        ],
        energyLabel: input.energyLabel,
    };
};
